module.exports = __webpack_public_path__ + "img/shopping-bg.69e684d4.jpg";